module.exports = __webpack_public_path__ + "img/qtv-slides-2-new.35f7cbc0.png";